.panel {
    width: 480px;
}

.title {
    margin-right: calc(-1 * var(--close-button-size));
    text-align: center;
}
